module.exports = __webpack_public_path__ + "img/chevron-down-white.aac3ffc1.svg";